import React from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'semantic-ui-react';
import InputField from '../../InputField';
import localization from '../../../../locales/localization';
import FormatIznosa from '../../FormatIznosa';

const styles = {
    kolicinaIcijena: {
        fontFamily: 'monospace'
    }
};

export default class EditableUslugaBodyCells extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Table.Cell collapsing>
                    <InputField
                        label={this.props.item.mjernaJedinica.naziv}
                        placeholder={localization.common.kol}
                        name="kolicina"
                        value={this.props.item.kolicina}
                        onChange={this.props.onChange.bind(this, this.props.item.sifra)}
                        isCjelobrojno={this.props.item.mjernaJedinica.isCjelobrojna}
                    />
                </Table.Cell>
                <Table.Cell collapsing>
                    <InputField
                        label={localization.common.eur}
                        placeholder={localization.common.cijena}
                        name="jedCijena"
                        value={this.props.item.jedCijena}
                        onChange={this.props.onChange.bind(this, this.props.item.sifra)}
                    />
                </Table.Cell>
                <Table.Cell textAlign="right" collapsing style={styles.kolicinaIcijena}>
                    <b>
                        {this.props.item.kolicina && this.props.item.jedCijena ? (
                            <FormatIznosa value={this.props.item.kolicina * this.props.item.jedCijena} />
                        ) : (
                            '-'
                        )}
                    </b>
                </Table.Cell>
                <Table.Cell collapsing>
                    <Button icon="delete" basic size="small" onClick={this.props.onRemoveItem.bind(this, this.props.item)} />
                </Table.Cell>
            </React.Fragment>
        );
    }
}

EditableUslugaBodyCells.propTypes = {
    item: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemoveItem: PropTypes.func.isRequired
};
